import { UserApi } from './userApi';
import { LoginApi } from './loginApi';
import { ProtocolsApi } from './protocolsApi';
import { SearchApi } from './searchApi';
import { DeceasedApi } from './deceasedApi';
import { ReferencesApi } from './referencesApi';
import { HandoverProtocolsApi } from './handoverProtocolsApi';
import { LabMatsApi } from './labmatsApi';
import { InsuranceClaimsApi } from './insuranceClaimsApi';
import { StatisticsApi } from './statisticsApi';
import { CommonApi } from './commonApi';
import { LabRequestsApi } from './labRequestsApi';
import { ComplementApi } from './complementApi';
import { RuianApi } from './ruianApi';

// Re-export for backward compatibility – new code should import from './types'
export type { Pagination, PaginatedResponse } from './types';

export const useApi = () => ({
  protocols: ProtocolsApi(),
  user: UserApi(),
  login: LoginApi(),
  search: SearchApi(),
  deceased: DeceasedApi(),
  references: ReferencesApi(),
  handoverProtocols: HandoverProtocolsApi(),
  labmats: LabMatsApi(),
  insuranceClaims: InsuranceClaimsApi(),
  statistics: StatisticsApi(),
  common: CommonApi(),
  labRequests: LabRequestsApi(),
  complement: ComplementApi(),
  ruian: RuianApi(),
});
